// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_AVATAR = "Opravdu chce\u0161 vymazat svoji fotku?";
export const PB_POST_HAS_BEEN_SUBMITTED = "P\u0159\u00edsp\u011bvek byl \u00fasp\u011b\u0161n\u011b zve\u0159ejn\u011bn\u00fd.";
export const USER_ALREADY_LIKED = "U\u017eivatelka je p\u0159id\u00e1na k obl\u00edben\u00fdm.";
export const USER_ALREADY_UNLIKED = "U\u017eivatelka byla odebr\u00e1na z obl\u00edben\u00fdch.";
export const USER_LIKED = "U\u017eivatelka byla p\u0159id\u00e1na k obl\u00edben\u00fdm.";
export const USER_UNLIKED = "U\u017eivatelka byla odebr\u00e1na z obl\u00edben\u00fdch.";
